import httpClient from './httpClient';

/**
 * Serviço utilitário para consumir as APIs de contatos do backend.
 */
export async function listarContatosPorParceiro(parceiroId) {
  const resp = await httpClient.get(`/api/contatos/por-parceiro/${parceiroId}`);
  return resp.data;
}

export async function buscarContato(id) {
  const resp = await httpClient.get(`/api/contatos/${id}`);
  return resp.data;
}

export async function salvarContato(contato) {
  const resp = await httpClient.post('/api/contatos', contato);
  return resp.data;
}

export async function atualizarContato(id, contato) {
  const resp = await httpClient.put(`/api/contatos/${id}`, contato);
  return resp.data;
}

export async function removerContato(id) {
  await httpClient.delete(`/api/contatos/${id}`);
}
